import React, {Component} from 'react';
import {connect} from 'react-redux'

import bindAll from 'lodash.bindall';
import RecordComponent from '../components/classguanli/guanli.jsx';
import {getStudentEvaluationRequest, deleteStudentEvaluationRequest,getClassEvaluationRequest} from "../service/reason";
import {getKerenListRequest,getClassByGradeRequest,getAllXuekeListRequest,addKerenRequest,delKerenRequest} from "../service/classGuanli";

import Prompt from '../components/prompt/prompt.jsx';
import {FILE_URL} from "../util/constants";
import defaultImg from '../img/bee.png';
import HomeComponent from "../components/home/home";

import PubSub from "pubsub-js";

class RecordContainer extends React.Component {

    constructor(props) {
        super(props)
        bindAll(this, [
            'deleteRecord',
            'handleScroll',
            'showPrompt',
            'delete',
            'handleImageErrored',
            'hideAllMenu',
            'clickNianji',
            'openClassValue',
            'getClassValue',
            'openClassValue2',
            'getClassValue2',
            'openClassValue3',
            'getClassValue3',
            'getKerenList',
            'getClassByGrade',
            'getAllXuekeList',
            'addKeren',
            'delKeren'
        ]);
        this.state = {
            recordList: [],
            isBottom: false,
            showPrompt:false,
            item:{},
            kerenList:[],
            nianjiList:[{nianji_code:'1',nianji_name:'一年级'},{nianji_code:'2',nianji_name:'二年级'},{nianji_code:'3',nianji_name:'三年级'},{nianji_code:'4',nianji_name:'四年级'},{nianji_code:'5',nianji_name:'五年级'},{nianji_code:'6',nianji_name:'六年级'}],
            nianji_code:'',
            nianji_name:'年级',
            banjiList:[],
            banji_code:'',
            banji_name:'班级',
            xuekeList:[],
            xueke_code:'',
            xueke_name:'学科',
            showNianji:false,
            showBanji:false,
            showXueke:false,
            classname:'',
            id:''//已添加的科任班级id
        }
    }

    hideAllMenu(){
        this.setState({
            showNianji:false,
            showBanji:false,
            showXueke:false
        });
    }

    componentDidMount() {

        document.addEventListener('click', this.hideAllMenu);

        window.addEventListener('scroll', this.handleScroll, true);


        this.getKerenList();
        this.getClassByGrade('1')
        this.getAllXuekeList('1')
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll, true);
    }

    addKeren(){

        if(this.state.nianji_code==''){
            this.showToast('请先选择年级',1500);
            return;
        }  if(this.state.banji_code==''){
            this.showToast('请先选择班级',1500);
            return;
        }  if(this.state.xueke_code==''){
            this.showToast('请先选择学科',1500);
            return;
        }

        addKerenRequest(this.state.xueke_code,this.state.xueke_name,this.state.banji_code,this.state.banji_name,this.state.nianji_code, (data) => {
            if (data.ret == '1') {
                this.getKerenList()
                this.showToast('添加成功',1500);
                PubSub.publish('kerenUpdate')

                this.setState({
                    nianji_code:'',
                    nianji_name:'年级',
                    banji_code:'',
                    banji_name:'班级',
                    xueke_code:'',
                    xueke_name:'学科',
                })

            }else {
                this.showToast(data.msg,1500);
            }

        })
    }

    delKeren(){
        console.log(this.state.id)
        delKerenRequest(this.state.id, (data) => {
            if (data.ret == '1') {
                this.getKerenList()
                PubSub.publish('kerenUpdate')
            }else {
                this.showToast(data.msg,1500);
            }
            this.showPrompt();
        })

    }

    showToast(msg,duration){
        duration=isNaN(duration)?3000:duration;
        var m = document.createElement('div');
        m.innerHTML = msg;
        m.style.cssText="min-width:180px; background:#000; opacity:0.6; height:auto;min-height: 30px; color:#fff; line-height:30px; text-align:center; border-radius:4px; position:fixed; top:45%; left:50%;transform: translate(-50%,-50%);padding:15px; z-index:999999;";
        document.body.appendChild(m);
        setTimeout(function() {
            var d = 0.5;
            m.style.webkitTransition = '-webkit-transform ' + d + 's ease-in, opacity ' + d + 's ease-in';
            m.style.opacity = '0';
            setTimeout(function() { document.body.removeChild(m) }, d * 1000);
        }, duration);
    }

    getAllXuekeList(grade){
        getAllXuekeListRequest(grade, (data) => {
            console.log(data)
            if (data.ret == '1') {
                this.setState({
                    xuekeList: data.data,
                    // xueke_code:data.data[0].code,
                    // xueke_name:data.data[0].name
                });
            } else {
                this.setState({
                    xuekeList: [],
                    xueke_code:'',
                    xueke_name:''
                });
            }
        });
    }

    getKerenList(){
        getKerenListRequest( (data) => {
            console.log(data)
            if (data.ret == '1') {
                this.setState({
                    kerenList: data.data.keren
                });
            } else {
                this.setState({
                    kerenList: []
                });
            }
        });
    }

    getClassByGrade(grade){
        getClassByGradeRequest(grade, (data) => {
            console.log(data)
            if (data.ret == '1') {
                this.setState({
                    banjiList: data.data,
                    // banji_code:data.data[0].classcode,
                    // banji_name:data.data[0].name
                });
            } else {
                this.setState({
                    banjiList: [],
                    banji_code:'',
                    banji_name:''
                });
            }
        });
    }

    clickNianji(id,classname){
        this.setState({
            classname:classname,
            id:id,
            showPrompt:true
        })
    }

    getClassValue(code,name){
        if(code==this.state.nianji_code){

        }else {
            this.getClassByGrade(code);
            this.getAllXuekeList(code);
        }
        this.setState({
            nianji_code:code,
            nianji_name:name,
            showNianji:false
        });

    }

    openClassValue(e){
        e.nativeEvent.stopImmediatePropagation();
        var show = !this.state.showNianji;
        this.setState({
            showNianji:show,
            showBanji:false,
            showXueke:false
        })
    }

    getClassValue2(code,name){
        if(code==this.state.banji_code){

        }else {

        }

        this.setState({
            banji_code:code,
            banji_name:name,
            showBanji:false
        });

    }

    openClassValue2(e){

        if(this.state.nianji_code==''){
            this.showToast('请先选择年级',1500);
            return;
        }

        e.nativeEvent.stopImmediatePropagation();
        var show = !this.state.showBanji;
        this.setState({
            showNianji:false,
            showBanji:show,
            showXueke:false
        })
    }

    getClassValue3(code,name){
        if(code==this.state.xueke_code){

        }else {
            // this.getStudentList(code);
            // this.getClassInfo(code);
        }

        this.setState({
            xueke_code:code,
            xueke_name:name,
            showXueke:false
        });

    }

    openClassValue3(e){

        if(this.state.nianji_code==''){
            this.showToast('请先选择年级',1500);
            return;
        }
        if(this.state.banji_code==''){
            this.showToast('请先选择班级',1500);
            return;
        }

        e.nativeEvent.stopImmediatePropagation();
        var show = !this.state.showXueke;
        this.setState({
            showNianji:false,
            showBanji:false,
            showXueke:show
        })
    }

    handleImageErrored(index){
        console.log('加载图片出错')
        var list = this.state.recordList;
        list[index].student_pic = defaultImg;

        this.setState({
            recordList:list
        });
    }

    handleScroll(event) {

        const clientHeight = event.target.clientHeight
        const scrollHeight = event.target.scrollHeight
        const scrollTop = event.target.scrollTop

        var plusHeight = clientHeight + parseInt(scrollTop);
        var isBottom = (plusHeight === scrollHeight)


        if (isBottom) {
            console.log('加载更多')
        } else {
            console.log('没到达底部')
        }

        if (plusHeight == scrollHeight) {
            //getTeacherPingjiaList('12',this.state.recordList.length,(data) => {

            // this.setState({
            //     recordList: this.state.recordList.concat(data.data.log)
            // });

            getStudentEvaluationRequest(this.props.banji_code, this.state.recordList.length, (data) => {
                console.log(data)
                if (data.ret == '1') {
                    var list = data.data;
                    for (let i = 0; i < list.length; i++) {
                        list[i].student_pic = list[i].student_pic==null||list[i].student_pic==''?'':FILE_URL+list[i].student_pic
                    }
                    this.setState({
                        recordList: this.state.recordList.concat(list)
                    });
                } else {

                }
            });

        }
    }


    handleCancel() {
        this.props.closeSelf();
    }

    showToast(msg,duration){
        duration=isNaN(duration)?3000:duration;
        var m = document.createElement('div');
        m.innerHTML = msg;
        m.style.cssText="min-width:180px; background:#000; opacity:0.6; height:auto;min-height: 30px; color:#fff; line-height:30px; text-align:center; border-radius:4px; position:fixed; top:45%; left:50%;transform: translate(-50%,-50%);padding:15px; z-index:999999;";
        document.body.appendChild(m);
        setTimeout(function() {
            var d = 0.5;
            m.style.webkitTransition = '-webkit-transform ' + d + 's ease-in, opacity ' + d + 's ease-in';
            m.style.opacity = '0';
            setTimeout(function() { document.body.removeChild(m) }, d * 1000);
        }, duration);
    }

    deleteRecord(item) {

        this.setState({
            item:item
        })
        this.showPrompt();

    }

    showPrompt(){
        var show = !this.state.showPrompt;
        this.setState({
            showPrompt:show
        })
    }

    delete(){
        var dongtai_id = this.state.item.dongtai_id;
        var dianzan_type = this.state.item.dianzan_type;
        var student_pid = this.state.item.student_pid;
        var dianzan_code = this.state.item.dianzan_code;
        var class_code = this.props.banji_code;

        deleteStudentEvaluationRequest(dongtai_id,dianzan_type,class_code,student_pid,dianzan_code, (data) => {
            console.log(data);
            if (data.ret === '1') {
                for (let i = 0; i < this.state.recordList.length; i++) {
                    if (this.state.recordList[i].dongtai_id === dongtai_id) {
                        this.state.recordList.splice(i, 1);
                        this.setState({
                            recordList: this.state.recordList
                        });
                    }
                }

                this.setState({
                    showPrompt:false
                })

                if(this.state.recordList.length==0){
                    getStudentEvaluationRequest(this.props.banji_code, '0', (data) => {
                        console.log(data)
                        var list = data.data;
                        for (let i = 0; i < list.length; i++) {
                            list[i].student_pic = list[i].student_pic==null||list[i].student_pic==''?'':FILE_URL+list[i].student_pic
                        }
                        this.setState({
                            recordList: list
                        });
                    });
                }

                this.showToast('删除成功',1000);
                this.props.deleteFinish();
            }
        });
    }

    render() {

        return (
            <div>
                <RecordComponent
                    recordList={this.state.recordList}
                    onRequestClose={this.props.closeSelf}
                    deleteRecord={this.deleteRecord}
                    handleImageErrored={this.handleImageErrored}
                    kerenList={this.state.kerenList}
                    nianjiList={this.state.nianjiList}
                    clickNianji={this.clickNianji}
                    nianji_code={this.state.nianji_code}
                    nianji_name={this.state.nianji_name}
                    showNianji={this.state.showNianji}
                    openClassValue={this.openClassValue}
                    getClassValue={this.getClassValue}
                    banjiList={this.state.banjiList}
                    banji_code={this.state.banji_code}
                    banji_name={this.state.banji_name}
                    showBanji={this.state.showBanji}
                    openClassValue2={this.openClassValue2}
                    getClassValue2={this.getClassValue2}
                    xuekeList={this.state.xuekeList}
                    xueke_code={this.state.xueke_code}
                    xueke_name={this.state.xueke_name}
                    showXueke={this.state.showXueke}
                    openClassValue3={this.openClassValue3}
                    getClassValue3={this.getClassValue3}
                    addKeren={this.addKeren}
                />
                {this.state.showPrompt?
                    <Prompt
                        label='删除班级'
                        title={'是否删除'+this.state.classname+'？'}
                        onCancel={this.showPrompt}
                        onOk={this.delKeren}
                    />
                :null}


            </div>

        )
    }


}

RecordContainer.propTypes = {
    // count: PropTypes.Number.isRequired,
}


const mapStateToProps = state => {
    return {
        msg: state.alert.msg,
        status: state.alert.status,
    }
}

const mapDispatchToProps = dispatch => {
    return {}
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RecordContainer);
